module.exports = "hls/videos/500_KMSAT15_2022_Common_Digital_Attacks-Spear_Phishing/video.m3u8"